export const StafferPetGodModeIcon = () => {
  /* Render */
  const render = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 20C3 18 2 12 5 6M16 20C21 18 22 12 19 6"
        stroke="#6d28d9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4 9L2 6L6 7M3 13L1 10L5 11M5 17L2 15L6 15M20 9L22 6L18 7M21 13L23 10L19 11M19 17L22 15L18 15"
        fill="#a78bfa"
        stroke="#6d28d9"
        strokeWidth=".8"
        strokeLinejoin="round"
      />
      <path
        d="M13 2L7 13H11L10 22L17 10H13L13 2Z"
        fill="#fbbf24"
        stroke="#78350f"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );

  return render();
};
